import { render, staticRenderFns } from "./pageGoodSpecificationPc.vue?vue&type=template&id=01aeb680&scoped=true"
import script from "./pageGoodSpecificationPc.vue?vue&type=script&lang=js"
export * from "./pageGoodSpecificationPc.vue?vue&type=script&lang=js"
import style0 from "./pageGoodSpecificationPc.vue?vue&type=style&index=0&id=01aeb680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aeb680",
  null
  
)

export default component.exports